import request from '../request';

// 修改用户信息
export function getUserDetail(params) {
    return request('/user/getUserDetail', {
        method: 'GET',
        params
    });
}

// 修改用户信息
export function updateUserInfo(params) {
    return request('/user/updateUser', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 上传头像
export function uploadUserAvatar(params) {
    return request('/user/uploadImage', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 修改密码
export function updatePassword(params) {
    return request('/user/modifyPassword', {
        type: 'formData',
        method: 'POST',
        params
    });
}

// 关注用户
export function attentionUser(params) {
    return request('/user/attentionUser', {
        method: 'GET',
        params
    });
}

// 取消关注用户
export function unAttentionUser(params) {
    return request('/user/unAttentionUser', {
        method: 'GET',
        params
    });
}

// 是否关注过用户
export function isAttentionUser(params) {
    return request('/user/isAttentionUser', {
        method: 'GET',
        params
    });
}

// 获取粉丝列表
export function getMyFans(params) {
    return request('/user/getMyFans', {
        method: 'GET',
        params
    });
}

// 获取关注列表
export function getMyAttentionUser(params) {
    return request('/user/getMyAttentionUser', {
        method: 'GET',
        params
    });
}

// 邮箱是否已注册
export function hasEmail(params) {
    return request('/user/hasEmail', {
        method: 'GET',
        params
    });
}
